import React from 'react';

import ShipFromOrigin from './ship-from-origin';
import SelectedPickupContact from './selected-pickup-contact';

import { usePickupSettingsContext, usePickupSettingsContextTypes } from '../contexts/pickup-settings-context';
import style from '../style.module.less';

const ShipFromSection = () => {
  usePickupSettingsContextTypes('ShipFromSection');
  const { selectedContact } = usePickupSettingsContext();
  return (
    <div className={style['ship-from-section']}>
      <ShipFromOrigin />
      <SelectedPickupContact selectedContact={selectedContact} />
    </div>
  );
};

export default ShipFromSection;
